<template>
  <div class="position-relative px-4">
    <VueSlickCarousel
      ref="carousel"
      class="mx-2"
      :arrows="true"
      :dots="true"
      v-bind="settings"
    >
      <slot />
    </VueSlickCarousel>
  </div>
</template>

<script>
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'

  export default {
    components: { VueSlickCarousel },
    data() {
      return {
        settings: {
          slidesToShow: 9,
          dots: false,
          infinite: false,
          responsive: [
            {
              breakpoint: 1200,
              settings:{
                slidesToShow: 6
              }
            },
            {
              breakpoint: 768,
              settings:{
                slidesToShow: 3,
                slidesToScroll: 3,
                centerMode: false
              }
            }
          ]
        }
      }
    },

    methods: {
      showPrev() {
        this.$refs.carousel.prev()
      },

      showNext() {
        this.$refs.carousel.next()
      },
    }
  }
</script>

<style>
    .slick-next, .slick-prev {
      font-size: 0;
      line-height: 0;
      position: absolute;
      top: 25%;
      cursor: pointer;
      background: none;
      width: 16px;
      height: 16px;
      border: none;
      border-right: 2px solid black;
      border-bottom: 2px solid black;
    }

    .slick-next, .slick-prev,
    .slick-next:focus, .slick-prev:focus {
      outline: none;
    }

    .slick-next {
      right: -20px;
      transform: rotate(-45deg);
    }

    .slick-prev {
      left: -20px;
      transform: rotate(135deg);
    }

    .slick-dots {
      display: none !important;
    }
</style>
